module.exports = __webpack_public_path__ + "img/input_arrow.e7f19352.svg";